<mat-card>
  <mat-card-header>
    <mat-card-title style="white-space: nowrap">{{ dialogTitle | translate }}</mat-card-title>
    <div class="header-actions">
      <app-export-to-excel-button (click)="exportToExcel()"></app-export-to-excel-button>
      <button
        *ngIf="isDialog"
        mat-icon-button
        matTooltip="{{ 'General.Close' | translate }}"
        (click)="onCloseButtonClick()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-card-header>

  <mat-card-content>
    <!-- Host/Gateway Details Section -->
    <div class="host-details">
      <div class="host-row-container">
      <div class="host-row">
        <div class="host-field">
          <label
            ><strong
              >{{ 'Column.' + datasource?.dialogType + '.hostName' | translate }}:</strong
            ></label
          >
          <a
            class="gateway-name-link"
            [routerLink]="['/tank', datasource?.tankInfo.hostUniqueId, 'details']"
            target="_blank"
          >
            {{ datasource?.tankInfo.hostName }} ({{ datasource?.tankInfo.hostRtu }})
          </a>
        </div>
        <div class="host-field">
          <label
            ><strong
              >{{ 'Column.' + datasource?.dialogType + '.StartCallSchedule' | translate }}:</strong
            ></label
          >
          <span>{{ datasource?.tankInfo.callScheduleStart || 'N/A' }}</span>
        </div>
        <div class="host-field">
          <label
            ><strong
              >{{ 'Column.' + datasource?.dialogType + '.LocationFormatted' | translate }}:</strong
            ></label
          >
          <span>{{ datasource?.tankInfo?.locationFormatted }}</span>
        </div>
        <div class="host-field">
          <label
            ><strong
              >{{ 'Column.' + datasource?.dialogType + '.DeviceModel' | translate }}:</strong
            ></label
          >
          <span>{{ datasource?.tankInfo.hostDeviceModel || 'N/A' }}</span>
        </div>
      </div>
      <div class="gateway-counts" *ngIf="isGatewayDialog">
        <label><strong>{{ connectionCountLabel }}:</strong></label>
        <span>{{ skyTankSensorLabel }}: {{ skyTankSensorCount }}</span>
        <span>{{ st90ClientLabel }}: {{ st90Count }}</span>
      </div>
      </div>
    </div>

    <div class="client-connections-section">
      <div class="table-container" *ngIf="!isGatewayDialog">
        <table mat-table [dataSource]="tankList" class="client-connections-table">
          <!-- Client/Sensor Name Column -->
          <ng-container matColumnDef="clientName">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Column.' + this.datasource?.dialogType + '.tankName' | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              <a
                class="client-name-link"
                (click)="onClientNameClick(client)"
                [routerLink]="['/tank', client.uniqueId, 'details']"
                target="_blank"
              >
                {{ client.tankName || 'N/A' }}
              </a>
            </td>
          </ng-container>

          <!-- RTU # Column -->
          <ng-container matColumnDef="rtuNumber">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Column.' + this.datasource?.dialogType + '.RTUNumber' | translate }}
            </th>
            <td mat-cell *matCellDef="let client">{{ client.rtuNumber || 'N/A' }}</td>
          </ng-container>

          <!-- Min # Column -->
          <ng-container matColumnDef="minNumber">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Column.' + this.datasource?.dialogType + '.MinNumber' | translate }}
            </th>
            <td mat-cell *matCellDef="let client">{{ client.min0 || 'N/A' }}</td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Column.' + this.datasource?.dialogType + '.PairedStatus' | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              <span class="status-badge" [class]="'status-' + client.statusString?.toLowerCase()">
                {{ client.statusString || 'N/A' }}
              </span>
            </td>
          </ng-container>

          <!-- Location / ID / Address Column -->
          <ng-container matColumnDef="locationFormatted">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Column.' + this.datasource?.dialogType + '.locationFormatted' | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let client"
              [class]="isClientLocationSameAsHost(client) ? 'location-text' : 'location-text-red'"
            >
              <span>
                {{ client.locationFormatted || 'N/A' }}
              </span>
            </td>
          </ng-container>

          <!-- Device Model Column -->
          <ng-container matColumnDef="deviceModel">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Column.' + this.datasource?.dialogType + '.DeviceModel' | translate }}
            </th>
            <td mat-cell *matCellDef="let client">{{ client.deviceModel || 'N/A' }}</td>
          </ng-container>

          <!-- Last Inventory Time Column -->
          <ng-container matColumnDef="lastInventoryTime">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'Column.' + this.datasource?.dialogType + '.lastInventoryTime' | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.lastInventoryTimeConverted || 'N/A' }}
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions" *ngIf="showActionButtons">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let client">
              <div class="action-buttons">
                <!--  ----- unassign/disconnect ----- -->
                <app-unassign-tank-button
                  [tankId]="client?.tankId"

                  [deviceCategory]="client?.deviceCategory"
                  #unassignTankButton
                  siteUsageTracker
                  (unassignComplete)="onUnassignComplete($event)"
                  [logCategory]="'TankSetup'"
                  [logName]="'Show_UnassignTankButtonClick'"
                >
                </app-unassign-tank-button>
                <!--  ----- move button ----- -->
                <app-tank-move-button
                  *ngIf="isClientDevice(client)"
                  [context]="client"
                  [uniqueId]="(client?.tankId ?? 0) * 10"
                  [disabled]="client?.isAffiliatedTank"
                  [billableOrgId]="datasource?.tankInfo.billableOrgId"
                  [buttonText]="'Move'"
                  [formMode]="'tank'"
                  #tankMoveButton
                  appAuthorization
                  [policy]="SecurityPolicies.CanMoveTank"
                  [policyOptions]="{ policyAction: 'Disable', componentRef: tankMoveButton }"
                  siteUsageTracker
                  [logCategory]="'TankSetup'"
                  [logName]="'Show_MoveTankButtonClick'"
                  (beforeOpen)="onBeforeOpen($event)"
                >
                </app-tank-move-button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
          <tr mat-row *matRowDef="let row; columns: getDisplayedColumns()"></tr>
        </table>
      </div>

      <div class="table-container" *ngIf="isGatewayDialog">
        <table class="client-connections-table gateway-connections-table">
          <thead>
            <tr>
              <th>{{ 'Column.' + this.datasource?.dialogType + '.tankName' | translate }}</th>
              <th>{{ 'Column.' + this.datasource?.dialogType + '.RTUNumber' | translate }}</th>
              <th>{{ 'Column.' + this.datasource?.dialogType + '.MinNumber' | translate }}</th>
              <th>{{ 'Column.' + this.datasource?.dialogType + '.PairedStatus' | translate }}</th>
              <th>{{ 'Column.' + this.datasource?.dialogType + '.locationFormatted' | translate }}</th>
              <th>{{ 'Column.' + this.datasource?.dialogType + '.DeviceModel' | translate }}</th>
              <th>{{ 'Column.' + this.datasource?.dialogType + '.lastInventoryTime' | translate }}</th>
              <th *ngIf="showActionButtons"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="section-header-row">
              <td [attr.colspan]="showActionButtons ? 8 : 7">{{ skyTankSensorLabel }}</td>
            </tr>
            <tr *ngFor="let client of sensorTankList">
              <td>
                <a
                  class="client-name-link"
                  (click)="onClientNameClick(client)"
                  [routerLink]="['/tank', client.uniqueId, 'details']"
                  target="_blank"
                >
                  {{ client.tankName || 'N/A' }}
                </a>
              </td>
              <td>{{ client.rtuNumber || 'N/A' }}</td>
              <td>{{ client.min0 || 'N/A' }}</td>
              <td>
                <span class="status-badge" [class]="'status-' + client.statusString?.toLowerCase()">
                  {{ client.statusString || 'N/A' }}
                </span>
              </td>
              <td [class]="isClientLocationSameAsHost(client) ? 'location-text' : 'location-text-red'">
                {{ client.locationFormatted || 'N/A' }}
              </td>
              <td>{{ client.deviceModel || 'N/A' }}</td>
              <td>{{ client.lastInventoryTimeConverted || 'N/A' }}</td>
              <td *ngIf="showActionButtons">
                <div class="action-buttons">
                  <app-unassign-tank-button
                    [tankId]="client?.tankId"
                    [deviceCategory]="client?.deviceCategory"
                    #unassignTankButton
                    siteUsageTracker
                    (unassignComplete)="onUnassignComplete($event)"
                    [logCategory]="'TankSetup'"
                    [logName]="'Show_UnassignTankButtonClick'"
                  >
                  </app-unassign-tank-button>
                  <app-tank-move-button
                    *ngIf="isClientDevice(client)"
                    [context]="client"
                    [uniqueId]="(client?.tankId ?? 0) * 10"
                    [disabled]="client?.isAffiliatedTank"
                    [billableOrgId]="datasource?.tankInfo.billableOrgId"
                    [buttonText]="'Move'"
                    [formMode]="'tank'"
                    #tankMoveButton
                    appAuthorization
                    [policy]="SecurityPolicies.CanMoveTank"
                    [policyOptions]="{ policyAction: 'Disable', componentRef: tankMoveButton }"
                    siteUsageTracker
                    [logCategory]="'TankSetup'"
                    [logName]="'Show_MoveTankButtonClick'"
                    (beforeOpen)="onBeforeOpen($event)"
                  >
                  </app-tank-move-button>
                </div>
              </td>
            </tr>

            <tr class="section-divider-row" *ngIf="st90TankList.length > 0">
              <td [attr.colspan]="showActionButtons ? 8 : 7"></td>
            </tr>
            <tr class="section-header-row" *ngIf="st90TankList.length > 0">
              <td [attr.colspan]="showActionButtons ? 8 : 7">{{ st90ClientLabel }}</td>
            </tr>
            <tr *ngFor="let client of st90TankList">
              <td>
                <a
                  class="client-name-link"
                  (click)="onClientNameClick(client)"
                  [routerLink]="['/tank', client.uniqueId, 'details']"
                  target="_blank"
                >
                  {{ client.tankName || 'N/A' }}
                </a>
              </td>
              <td>{{ client.rtuNumber || 'N/A' }}</td>
              <td>{{ client.min0 || 'N/A' }}</td>
              <td>
                <span class="status-badge" [class]="'status-' + client.statusString?.toLowerCase()">
                  {{ client.statusString || 'N/A' }}
                </span>
              </td>
              <td [class]="isClientLocationSameAsHost(client) ? 'location-text' : 'location-text-red'">
                {{ client.locationFormatted || 'N/A' }}
              </td>
              <td>{{ client.deviceModel || 'N/A' }}</td>
              <td>{{ client.lastInventoryTimeConverted || 'N/A' }}</td>
              <td *ngIf="showActionButtons">
                <div class="action-buttons">
                  <app-unassign-tank-button
                    [tankId]="client?.tankId"
                    [deviceCategory]="client?.deviceCategory"
                    #unassignTankButton
                    siteUsageTracker
                    (unassignComplete)="onUnassignComplete($event)"
                    [logCategory]="'TankSetup'"
                    [logName]="'Show_UnassignTankButtonClick'"
                  >
                  </app-unassign-tank-button>
                  <app-tank-move-button
                    *ngIf="isClientDevice(client)"
                    [context]="client"
                    [uniqueId]="(client?.tankId ?? 0) * 10"
                    [disabled]="client?.isAffiliatedTank"
                    [billableOrgId]="datasource?.tankInfo.billableOrgId"
                    [buttonText]="'Move'"
                    [formMode]="'tank'"
                    #tankMoveButton
                    appAuthorization
                    [policy]="SecurityPolicies.CanMoveTank"
                    [policyOptions]="{ policyAction: 'Disable', componentRef: tankMoveButton }"
                    siteUsageTracker
                    [logCategory]="'TankSetup'"
                    [logName]="'Show_MoveTankButtonClick'"
                    (beforeOpen)="onBeforeOpen($event)"
                  >
                  </app-tank-move-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<ng-template #moveConfirmationTemplate>
  <i class="fas fa-dolly"></i>&nbsp;
  <span class="button-text">{{ moveButtonMessage }}</span>
</ng-template>
